import MemberAdministrationPage from './MemberAdministrationPage';
export default MemberAdministrationPage;